/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import CommodityTypeList from './component/commodityTypeList'
import { Spin } from 'antd'

class ClubCommodityType extends React.Component {
  static defaultProps = {
    clubCommodityType: [],
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubCommodityType().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { clubCommodityType } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <CommodityTypeList
            list={clubCommodityType}
            fetchSetCommodityType={this.props.fetchSetCommodityType}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubCommodityType: state.getClubCommodityType.clubCommodityType,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubCommodityType))



// WEBPACK FOOTER //
// ./src/containers/ClubCommodityType/index.js